import { CRQ_STATUSES, getStatusParameter } from 'AppSrc/core/crq/crq-statuses';
// import moment from 'moment-timezone';
import { CREATE_CRQ } from 'AppSrc/core/components/create-crq-screen/create-crq-screen-consts';
import { sectionParameterFieldMap } from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/field-parameter-map';
import { MOBILE, FIXED } from 'AppSrc/core/components/forms/value-dependency-constants';
// import { getFieldValueForParameters } from './common-logic';
import displayOptionsJSON from 'AppSrc/core/components/forms/data/display-options.json';
import {
  getFieldValueForParameters,
  getIsOlaCrq,
  getTimingValue,
  ChangeAnalyst,
  GetStatusReason,
  getIsInternationalCrq,
  isCrqEmergency,
} from './common-logic';



// DMB: Based on the TIL error when initially connecting to TIL
// we believe the correct mobile value for default_priority is 'Low'
// this is consistent with the display options values.
const DEFAULT_PRIORITY = {
  [MOBILE]: 'Low',
  [FIXED]: '3',
};

const DEFAULT_URGENCY = {
  [MOBILE]: '4-Low',
  [FIXED]: '4000',
};

const DEFAULT_CHANGE_MANAGER_GROUP = 'Change Management';
const DEFAULT_ICM_CHANGE_MANAGER_GROUP = 'VNO INCP Change Management';
const DEFAULT_CHANGE_MANAGER_FIXED = 'ace.manager';

const DEFAULT_IMPACT_MOBILE = '2-Significant/Large';

const getFormDataFromState = (state) => state.mainForm.formData[CREATE_CRQ];

const getExistingCrqIdFromState = (state) => {
  const crqData = getFormDataFromState(state);
  return crqData ? crqData.crqId : null;
};

// to get value from serivice ICM if matching then true
const getIsServiceFromICM = (formData) => {
  const crqService = formData.dataByFormSectionId.CHANGE_DETAILS.dataByFieldId.services.value;
  // const serVice = 'Network: International Data & IP (IVC/IPX)';
  // console.log('displayJson', displayOptionsJSON['services-fixed-internationalcm'], crqService);
  const isIcmNetwork = getIsInternationalCrq(formData);
  console.log('is ICM11111', isIcmNetwork);
  return displayOptionsJSON['services-fixed-internationalcm'].some((servicesvalues) => crqService === servicesvalues.value) && isIcmNetwork;
};

const getCrqParametersFromFormDataAndUser = (formData, user, newStatus = null, selectedReason, isPostponeReason, isShowCrqAction, ispostponeReason1, ispostponeReason2, ispostponeReason3, postponeStatus, postponeStatusReason, mobilePostponeStatusReason) => {
  const crqData = formData;
  if (!crqData) { return null; }
  // const isOLOCrq = getIsOlaCrq(formData);
  const changeDetails = 'CHANGE_DETAILS';
  const isOloByService = formData.dataByFormSectionId[changeDetails] ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: Other Licensed Operator (OLO)' || formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value === 'Network: International Other Licensed Operator (OLO)' : null;
  const isOLOCrq = getIsOlaCrq(formData) || isOloByService;
  const isEmergency = isCrqEmergency(formData);
  console.log('formdata4', isOloByService, isOLOCrq);

  // create flag if CRQ is international
  console.log('is ICM333333', crqData);
  const isInterCm = getIsServiceFromICM(formData);
  // const isInterCm = getIsInternationalCrq(formData);
  console.log('is ICM2222', isInterCm);
  const params = {};

  /* parameters from form section data */
  sectionParameterFieldMap.forEach(({ sectionId, fields }) => {
    fields.forEach(({
      param,
      field,
      asNumber,
      asCommaSeparatedString,
      asArray,
    }) => {
      params[param] = getFieldValueForParameters({
        formData: crqData,
        sectionId,
        fieldId: field,
        asNumber,
        asCommaSeparatedString,
        asArray,
      });
    });
  });

  params.network = isInterCm ? 'fixed' : params.network;
  const network = params.network;

  // network === 'fixedOlo' ? params.network === 'fixed' : params.network;
  if (network === 'fixedOlo') {
    params.timing = getTimingValue(crqData);
  }
  if (params.region === 'N/A') {
    params.region = null;
  }
  if (params.site_group === 'N/A') {
    params.site_group = null;
  }
  // status - new CRQs go into planning
  const statusForNewCrqs = CRQ_STATUSES.coordinator;
  const existingStatus = crqData.status || statusForNewCrqs;
  // maintain existing status if no new status passed in
  const status = newStatus || existingStatus;

  params.status = getStatusParameter(status, network);
  if (crqData.postponeReason1) params.postpone_reason1 = crqData.postponeReason1;
  if (crqData.postponeReason2) params.postpone_reason2 = crqData.postponeReason2;
  if (crqData.postponeReason3) params.postpone_reason3 = crqData.postponeReason3;
  // status reason is undefined when creating a new crq
  // params.status_reason = crqData.statusReason ? crqData.statusReason : null;
  if (((network === 'fixed') || (network === 'mobile') || (network === 'fixedOlo')) && !isShowCrqAction && !isPostponeReason && !isEmergency) {
    params.status_reason = crqData.statusReason ? crqData.statusReason : null;
    if ((selectedReason === '1000') || (selectedReason === 'No Longer Required')) {
      params.status_reason = params.status_reason === null ? selectedReason : null;
      console.log('>>> inner >> 2st network', selectedReason, params.status_reason, crqData.statusReason);
    }
    console.log('>>> 1st network', selectedReason, params.status_reason, crqData.statusReason);
  }
  else if (network === 'fixed' && isShowCrqAction && isPostponeReason) {
    // maintain existing status if no new status passed in
    params.status = getStatusParameter(postponeStatus, network);
    params.status_reason = postponeStatusReason;
    if (!ispostponeReason1 && !ispostponeReason2 && !ispostponeReason3) params.postpone_reason1 = selectedReason;
    if (ispostponeReason1 && !ispostponeReason2 && !ispostponeReason3) params.postpone_reason2 = selectedReason;
    if (ispostponeReason1 && ispostponeReason2 && !ispostponeReason3) params.postpone_reason3 = selectedReason;
  }
  else if (network === 'mobile' && isShowCrqAction && isPostponeReason) {
    params.status = getStatusParameter(postponeStatus, network);
    params.status_reason = mobilePostponeStatusReason;
    if (!ispostponeReason1 && !ispostponeReason2 && !ispostponeReason3) params.postpone_reason1 = selectedReason;
    if (ispostponeReason1 && !ispostponeReason2 && !ispostponeReason3) params.postpone_reason2 = selectedReason;
    if (ispostponeReason1 && ispostponeReason2 && !ispostponeReason3) params.postpone_reason3 = selectedReason;
  }
  else if (isShowCrqAction && (params.status === 'Cancelled' || params.status === '12')) {
    params.status_reason = selectedReason;
  }
  else {
    params.status_reason = null;
  }

  if (isEmergency && !isShowCrqAction) {
    console.log('>>> 1st network isemergency', selectedReason, params.status_reason, crqData.statusReason);
    params.status_reason = crqData.statusReason === '10500' ? crqData.statusReason : selectedReason;
  }
  if (isEmergency && (params.status === 'Cancelled' || params.status === '12')) {
    params.status_reason = crqData.statusReason ? crqData.statusReason : selectedReason;
  }
  if (isEmergency && (params.status === 'Closed' || params.status === '11')) {
    params.status_reason = crqData.statusReason ? crqData.statusReason : selectedReason;
  }
  console.log('>>> 1st network isemergency', selectedReason, params.status_reason, crqData.statusReason, params);
  // params.status_reason = crqData.statusReason ? crqData.statusReason : null;
  // Mobile Remedy Comms Alignment VFTO-905
  const riskValue = crqData.riskValue;
  if ((riskValue === 'Risk Level 3' || riskValue === 'Risk Level 4') && network === MOBILE && params.comms_required === 'Yes') {
    params.approval_group = 'Mobile Communications Check';
  }
  if ((riskValue === 'Risk Level 1' || riskValue === 'Risk Level 2') && network === MOBILE && params.comms_required === 'Yes' && isEmergency) {
    params.approval_group = 'Mobile Communications Check';
  }
  // Add #_FSI keyword on summary of change if first site implementaion is Yes
  const fsi = '#FSI_';
  const fsiCheck = params.summary.substring(0, 5);
  const hasFSI = fsiCheck === '#FSI_' ? true : false;
  if (params.first_site_implementation === 'Yes' && hasFSI === false) {
    // It will be add #FSI_
    params.summary = `${fsi}${params.summary}`;
  }
  else if (params.first_site_implementation === 'No' && hasFSI === true) {
    // It Will be remove #FSI_ if first site is no
    params.summary = params.summary.replace('#FSI_', '');
  }
  console.log('>>>Create param AFter', params.summary);
  // risk and coordinator
  params.risk_level = crqData.riskValue;
  params.coordinator = crqData.coordinatorId;
  params.coordinator_name = crqData.coordinatorName;
  // NOTE this will be null if it is the logged in coordinator
  // but there is no sensible value for us to send in this circumstance
  params.coordinator_group = crqData.coordinatorGroup || '';
  // peer reviewer parameters
  params.peer_reviewer = crqData.peerReviewerId;
  params.peer_reviewer_group = crqData.peerReviewerGroup;
  params.peer_reviewer_name = crqData.peerReviewerName;
  // data from auth
  const {
    firstName,
    lastName,
    remedyIds,
  } = user;

  // requester is the remedy id of logged in user, unless existing crq already has requester value
  params.requester = crqData.requester ? crqData.requester : remedyIds[network === 'fixedOlo' ? 'fixed' : network];
  // requester name is firstname and lastname of the logged in user, unless existing crq already has requester_name
  params.requester_name = crqData.requesterName ? crqData.requesterName : `${firstName} ${lastName}`;

  // static values for hidden fields
  params.priority = DEFAULT_PRIORITY[network === 'fixedOlo' ? 'fixed' : network];
  params.urgency = DEFAULT_URGENCY[network === 'fixedOlo' ? 'fixed' : network];
  params.change_manager = DEFAULT_CHANGE_MANAGER_FIXED;
  params.change_manager_group = isInterCm ? DEFAULT_ICM_CHANGE_MANAGER_GROUP : DEFAULT_CHANGE_MANAGER_GROUP;
  // I thought we might require this for additional Risk Analysis question, but it' not of any use right now.
  // params.technology_plan_required = 'abc';
  // params.technology_plan_exclusion = '';

  // default value for impact on mobile. It is a field for fixed
  if (network === MOBILE) {
    params.impact = DEFAULT_IMPACT_MOBILE;
  }

  // Comms Status for fixed
  if (network === 'fixed' && (params.impact === '1000' || params.impact === '2000')) {
    params.comms_status_flag = 'InitialCommsRequired';
  }
  else if (network === 'fixed' && (params.impact === '3000' || params.impact === '4000')) {
    params.comms_status_flag = 'CommsNotRequired';
  }

  // DVB 15/06/2020 to get us through SIT, we send up default values for
  // the relationships section fields in 1b. These will be replaced by actual values
  // from the relationships section
  // TODO - remove lines below when implementing relationships section
  if (network === MOBILE) {
    params.rel_incident_id = 'Incident';
    // params.rel_project_id = 'Project';
    // params.rel_configitem_id = 'Config item';
  }

  // The following lines were used to send fields up to the endpoint that
  // were not implemented as part of the form, but didn't have a sensible
  // default value. This is commented out as we currently have values for
  // all the api fields
  /*
  // unknown fields, pass up as null
  const unknownFields = [
    // fields that should be included, but set to null
  ];
  unknownFields.forEach((param) => {
    params[param] = null;
  });
  */
  console.log('is ICM 4444', isInterCm);
  if (isOLOCrq || isInterCm || (network !== 'fixed' && network !== 'mobile')) {
    params.network = 'fixed';
    params.other_line_operator = isInterCm ? 'No' : 'Yes';
    console.log('is ICM 3333', isInterCm);
  }
  else {
    params.other_line_operator = 'No';
  }
  // Change analyst
  if (params.status_reason === '10500' && params.status === '4') {
    params.circuit_check_analyst = ChangeAnalyst(crqData);
  }
  // Map adjacent_remedy_ref when creating related mobile ticket on fixed network
  // if (network === 'fixed' && params.status_reason === '10500' && params.status === '4') {
  //   const relatedCRQId = window.sessionStorage.getItem('relatedCRQId');
  //   params.adjacent_remedy_ref = relatedCRQId;
  //   console.log('MAP param 1', relatedCRQId, params.adjacent_remedy_ref);
  // }
  // Map related CRQ id if available or asign null for every edit stage
  if ((network === 'fixed' || network === 'mobile')) {
    const getCurrentAdjacentRemedyRef = window.sessionStorage.getItem('getCurrentAdjacentRemedyRef');
    console.log('MAP param 2', network, getCurrentAdjacentRemedyRef, params.adjacent_remedy_ref);
    // Add null
    if (getCurrentAdjacentRemedyRef === 'null') {
      console.log('MAP param 3', params.adjacent_remedy_ref);
      params.adjacent_remedy_ref = null;
    }
    else {
      console.log('MAP param 055');
      params.adjacent_remedy_ref = getCurrentAdjacentRemedyRef;
    }
  }
  console.log('MAP param 5', params.adjacent_remedy_ref, params.status_reason, window.location.href);
  // if ((params.status === '10' || params.status === '11') && params.network === 'fixed') {
  //   if (params.cause_an_incident === 'Yes') {
  //     params.cause_an_incident = '10';
  //   }
  //   if (params.cause_an_incident === 'No') {
  //     params.cause_an_incident = '20';
  //   }
  //   if (params.deliver_expected_benefits === 'Yes') {
  //     params.deliver_expected_benefits = '10';
  //   }
  //   if (params.deliver_expected_benefits === 'No') {
  //     params.deliver_expected_benefits = '20';
  //   }
  //   if (params.follow_approved_plan === 'Yes') {
  //     params.follow_approved_plan = '10';
  //   }
  //   if (params.follow_approved_plan === 'No') {
  //     params.follow_approved_plan = '20';
  //   }
  //   if (params.complete_within_approved_window === 'Yes') {
  //     params.complete_within_approved_window = '10';
  //   }
  //   if (params.complete_within_approved_window === 'No') {
  //     params.complete_within_approved_window = '20';
  //   }
  //   if (params.change_regressed === 'Yes') {
  //     params.change_regressed = '10';
  //   }
  //   if (params.change_regressed === 'No') {
  //     params.change_regressed = '20';
  //   }
  //   if (params.additional_Impact === 'Yes') {
  //     params.additional_Impact = '10';
  //   }
  //   if (params.additional_Impact === 'No') {
  //     params.additional_Impact = '20';
  //   }
  //   if (params.impacted_inventory_updated === 'Yes') {
  //     params.impacted_inventory_updated = '10';
  //   }
  //   if (params.impacted_inventory_updated === 'No') {
  //     params.impacted_inventory_updated = '20';
  //   }
  //   if (params.impacted_inventory_updated === undefined) {
  //     params.impacted_inventory_updated = '30';
  //   }
  // }
  if ((params.status === '10' || params.status === '11') && params.network === 'fixed') {
    if (params.impacted_inventory_updated === undefined) {
      params.impacted_inventory_updated = '30';
    }
  }
  if (params.status === '10' || params.status === 'Completed') {
    params.status_reason = GetStatusReason(formData);
  }
  console.log('main inner param', params);
  return params;
};

const getCrqParametersFromFormDataAndUserChangeAnalyst = (formData, user, newStatus = null, selectedReason, isPostponeReason, isShowCrqAction, ispostponeReason1, ispostponeReason2, ispostponeReason3, postponeStatus, postponeStatusReason, mobilePostponeStatusReason) => {
  const crqData = formData;
  const isInterCm = getIsServiceFromICM(formData);
  // const isInterCm = getIsInternationalCrq(formData);
  if (!crqData) { return null; }

  const params = {};
  /* parameters from form section data */
  sectionParameterFieldMap.forEach(({ sectionId, fields }) => {
    fields.forEach(({
      param,
      field,
      asNumber,
      asCommaSeparatedString,
      asArray,
    }) => {
      params[param] = getFieldValueForParameters({
        formData: crqData,
        sectionId,
        fieldId: field,
        asNumber,
        asCommaSeparatedString,
        asArray,
      });
    });
  });
  params.network = isInterCm ? 'fixed' : params.network;
  const network = params.network;
  // status - new CRQs go into planning
  const statusForNewCrqs = CRQ_STATUSES.coordinator;
  const existingStatus = crqData.status || statusForNewCrqs;
  // Map adjacent_remedy_ref when creating related mobile ticket on fixed network
  console.log('status map param 00', network, formData.statusReason, formData.status, formData);
  if (network === 'fixed' && formData.statusReason === '10500' && formData.status === '4') {
    const relatedCRQId = window.sessionStorage.getItem('relatedCRQId');
    const getCurrentAdjacentRemedyRef = window.sessionStorage.getItem('getCurrentAdjacentRemedyRef');
    const filteredRemedyRef = getCurrentAdjacentRemedyRef === 'null' ? null : getCurrentAdjacentRemedyRef;
    params.adjacent_remedy_ref = relatedCRQId ? relatedCRQId : filteredRemedyRef;
    console.log('MAP param 11 ana', relatedCRQId, params.adjacent_remedy_ref, getCurrentAdjacentRemedyRef);
  }
  else if (network === 'fixed' && (params.impact === '3000' || params.impact === '4000')) {
    params.adjacent_remedy_ref = null;
  }
  // Assign related remedy ID if available or sent null if not
  else if ((network === 'fixed' || network === 'mobile')) {
    const getCurrentAdjacentRemedyRef = window.sessionStorage.getItem('getCurrentAdjacentRemedyRef');
    console.log('MAP param 2 ana', getCurrentAdjacentRemedyRef, params.adjacent_remedy_ref);
    // Add null
    if (getCurrentAdjacentRemedyRef === 'null') {
      console.log('MAP param 3 ana', params.adjacent_remedy_ref);
      params.adjacent_remedy_ref = null;
    }
    else {
      console.log('MAP param 4 ana', params.adjacent_remedy_ref);
      params.adjacent_remedy_ref = getCurrentAdjacentRemedyRef;
    }
  }
  console.log('MAP param 55 ana', params.adjacent_remedy_ref);
  // // maintain existing status if no new status passed in
  // const status = newStatus || existingStatus;
  // params.status = getStatusParameter(status, network);
  if (formData.statusReason === '10500') {
    params.status_reason = null;
    params.status = '5';
  }
  else {
    params.status_reason = (network === 'fixed' && (params.impact === '1000' || params.impact === '2000')) ? '10500' : null;
    params.status = formData.status;
  }

  if (crqData.postponeReason1) params.postpone_reason1 = crqData.postponeReason1;
  if (crqData.postponeReason2) params.postpone_reason2 = crqData.postponeReason2;
  if (crqData.postponeReason3) params.postpone_reason3 = crqData.postponeReason3;
  // status reason is undefined when creating a new crq
  // params.status_reason = crqData.statusReason ? crqData.statusReason : null;
  // if ((network === 'fixed' || 'mobile') && !isShowCrqAction && !isPostponeReason) {
  //   params.status_reason = crqData.statusReason ? crqData.statusReason : '10';
  // }
  if (network === 'fixed' && isShowCrqAction && isPostponeReason) {
    // maintain existing status if no new status passed in
    params.status = getStatusParameter(postponeStatus, network);
    params.status_reason = postponeStatusReason;
    if (!ispostponeReason1 && !ispostponeReason2 && !ispostponeReason3) params.postpone_reason1 = selectedReason;
    if (ispostponeReason1 && !ispostponeReason2 && !ispostponeReason3) params.postpone_reason2 = selectedReason;
    if (ispostponeReason1 && ispostponeReason2 && !ispostponeReason3) params.postpone_reason3 = selectedReason;
  }
  else if (network === 'mobile' && isShowCrqAction && isPostponeReason) {
    params.status = getStatusParameter(postponeStatus, network);
    params.status_reason = mobilePostponeStatusReason;
    if (!ispostponeReason1 && !ispostponeReason2 && !ispostponeReason3) params.postpone_reason1 = selectedReason;
    if (ispostponeReason1 && !ispostponeReason2 && !ispostponeReason3) params.postpone_reason2 = selectedReason;
    if (ispostponeReason1 && ispostponeReason2 && !ispostponeReason3) params.postpone_reason3 = selectedReason;
  }
  else if (isShowCrqAction && (params.status === 'Cancelled' || params.status === '12')) {
    params.status_reason = selectedReason;
  }
  // else {
  //   params.status_reason = null;
  // }
  // params.statusReason = crqData.status_reason ? crqData.status_reason : null;
  // status reason is undefined when creating a new crq
  console.log('existingStaus', existingStatus, params.statusReason);
  // since we dont need all the data for circuitcheck crq upsert, so passing reqd in parameters and commenting the rest in case we need it in future

  // risk and coordinator
  params.risk_level = crqData.riskValue;
  params.coordinator = crqData.coordinatorId;
  params.coordinator_name = crqData.coordinatorName;
  // NOTE this will be null if it is the logged in coordinator
  // but there is no sensible value for us to send in this circumstance
  params.coordinator_group = crqData.coordinatorGroup || '';
  // peer reviewer parameters
  params.peer_reviewer = crqData.peerReviewerId;
  params.peer_reviewer_group = crqData.peerReviewerGroup;
  params.peer_reviewer_name = crqData.peerReviewerName;


  // data from auth
  const {
    firstName,
    lastName,
    remedyIds,
  } = user;

  // requester is the remedy id of logged in user, unless existing crq already has requester value
  params.requester = crqData.requester ? crqData.requester : remedyIds[network];
  // requester name is firstname and lastname of the logged in user, unless existing crq already has requester_name
  params.requester_name = crqData.requesterName ? crqData.requesterName : `${firstName} ${lastName}`;

  // static values for hidden fields
  params.priority = DEFAULT_PRIORITY[network];
  params.urgency = DEFAULT_URGENCY[network];
  params.change_manager = DEFAULT_CHANGE_MANAGER_FIXED;
  params.change_manager_group = isInterCm ? DEFAULT_ICM_CHANGE_MANAGER_GROUP : DEFAULT_CHANGE_MANAGER_GROUP;

  // default value for impact on mobile. It is a field for fixed
  if (network === MOBILE) {
    params.impact = DEFAULT_IMPACT_MOBILE;
  }

  // DVB 15/06/2020 to get us through SIT, we send up default values for
  // the relationships section fields in 1b. These will be replaced by actual values
  // from the relationships section
  // TODO - remove lines below when implementing relationships section
  if (network === MOBILE) {
    params.rel_incident_id = 'Incident';
    // params.rel_project_id = 'Project';
    // params.rel_configitem_id = 'Config item';
  }

  // The following lines were used to send fields up to the endpoint that
  // were not implemented as part of the form, but didn't have a sensible
  // default value. This is commented out as we currently have values for
  // all the api fields
  /*
  // unknown fields, pass up as null
  const unknownFields = [
    // fields that should be included, but set to null
  ];
  unknownFields.forEach((param) => {
    params[param] = null;
  });
  */
  return params;
};


// Following method is used for Assign to me update API call params
const getCrqParametersFromFormDataAndUserAssignToMe = (formData, user, newStatus = null, isAssignTrue, newReAssigneId, selectedReason, isPostponeReason, isShowCrqAction, ispostponeReason1, ispostponeReason2, ispostponeReason3, postponeStatus, postponeStatusReason, mobilePostponeStatusReason) => {
  const crqData = formData;
  const isInterCm = getIsServiceFromICM(formData);
  // const isInterCm = getIsInternationalCrq(formData);
  if (!crqData) { return null; }

  const params = {};

  /* parameters from form section data */
  sectionParameterFieldMap.forEach(({ sectionId, fields }) => {
    fields.forEach(({
      param,
      field,
      asNumber,
      asCommaSeparatedString,
      asArray,
    }) => {
      params[param] = getFieldValueForParameters({
        formData: crqData,
        sectionId,
        fieldId: field,
        asNumber,
        asCommaSeparatedString,
        asArray,
      });
    });
  });
  params.network = isInterCm ? 'fixed' : params.network;
  const network = params.network;
  // status - new CRQs go into planning
  const statusForNewCrqs = CRQ_STATUSES.coordinator;
  // if user re assing circuitcheck analyst
  const hasCircuitCheckAnalystId = newReAssigneId;
  const userName = hasCircuitCheckAnalystId ? hasCircuitCheckAnalystId : user.id;
  const circuitCheckAnalyst = isAssignTrue ? userName : null;
  const existingStatus = crqData.status || statusForNewCrqs;
  // maintain existing status if no new status passed in
  const status = newStatus || existingStatus;
  params.status = getStatusParameter(status, network);
  // status reason is undefined when creating a new crq
  // params.status_reason = crqData.statusReason ? crqData.statusReason : null;
  if (network === 'fixed') {
    params.status_reason = crqData.statusReason ? crqData.statusReason : null;
  }
  else {
    params.status_reason = null;
  }

  if (crqData.postponeReason1) params.postpone_reason1 = crqData.postponeReason1;
  if (crqData.postponeReason2) params.postpone_reason2 = crqData.postponeReason2;
  if (crqData.postponeReason3) params.postpone_reason3 = crqData.postponeReason3;
  // status reason is undefined when creating a new crq
  // params.status_reason = crqData.statusReason ? crqData.statusReason : null;
  // if ((network === 'fixed' || 'mobile') && !isShowCrqAction && !isPostponeReason) {
  //   params.status_reason = crqData.statusReason ? crqData.statusReason : '10';
  // }
  if (network === 'fixed' && isShowCrqAction && isPostponeReason) {
    // maintain existing status if no new status passed in
    params.status = getStatusParameter(postponeStatus, network);
    params.status_reason = postponeStatusReason;
    if (!ispostponeReason1 && !ispostponeReason2 && !ispostponeReason3) params.postpone_reason1 = selectedReason;
    if (ispostponeReason1 && !ispostponeReason2 && !ispostponeReason3) params.postpone_reason2 = selectedReason;
    if (ispostponeReason1 && ispostponeReason2 && !ispostponeReason3) params.postpone_reason3 = selectedReason;
  }
  else if (network === 'mobile' && isShowCrqAction && isPostponeReason) {
    params.status = getStatusParameter(postponeStatus, network);
    params.status_reason = mobilePostponeStatusReason;
    if (!ispostponeReason1 && !ispostponeReason2 && !ispostponeReason3) params.postpone_reason1 = selectedReason;
    if (ispostponeReason1 && !ispostponeReason2 && !ispostponeReason3) params.postpone_reason2 = selectedReason;
    if (ispostponeReason1 && ispostponeReason2 && !ispostponeReason3) params.postpone_reason3 = selectedReason;
  }
  else if (isShowCrqAction && (params.status === 'Cancelled' || params.status === '12')) {
    params.status_reason = selectedReason;
  }
  // else {
  // Mobile Remedy Comms Alignment VFTO-905
  const riskValue = crqData.riskValue;
  if ((riskValue === 'Risk Level 3' || riskValue === 'Risk Level 4') && network === MOBILE) {
    params.approval_group = 'Mobile Communications Check';
  }
  // risk and coordinator
  params.risk_level = crqData.riskValue;
  params.coordinator = crqData.coordinatorId;
  params.coordinator_name = crqData.coordinatorName;
  // NOTE this will be null if it is the logged in coordinator
  // but there is no sensible value for us to send in this circumstance
  params.coordinator_group = crqData.coordinatorGroup || '';
  // peer reviewer parameters
  params.peer_reviewer = crqData.peerReviewerId;
  params.peer_reviewer_group = crqData.peerReviewerGroup;
  params.peer_reviewer_name = crqData.peerReviewerName;
  params.circuit_check_analyst = circuitCheckAnalyst;


  // data from auth
  const {
    firstName,
    lastName,
    remedyIds,
  } = user;

  // requester is the remedy id of logged in user, unless existing crq already has requester value
  params.requester = crqData.requester ? crqData.requester : remedyIds[network];
  // requester name is firstname and lastname of the logged in user, unless existing crq already has requester_name
  params.requester_name = crqData.requesterName ? crqData.requesterName : `${firstName} ${lastName}`;

  // static values for hidden fields
  params.priority = DEFAULT_PRIORITY[network];
  params.urgency = DEFAULT_URGENCY[network];
  params.change_manager = DEFAULT_CHANGE_MANAGER_FIXED;
  params.change_manager_group = isInterCm ? DEFAULT_ICM_CHANGE_MANAGER_GROUP : DEFAULT_CHANGE_MANAGER_GROUP;

  // default value for impact on mobile. It is a field for fixed
  if (network === MOBILE) {
    params.impact = DEFAULT_IMPACT_MOBILE;
  }

  // DVB 15/06/2020 to get us through SIT, we send up default values for
  // the relationships section fields in 1b. These will be replaced by actual values
  // from the relationships section
  // TODO - remove lines below when implementing relationships section
  if (network === MOBILE) {
    params.rel_incident_id = 'Incident';
    // params.rel_project_id = 'Project';
    // params.rel_configitem_id = 'Config item';
  }

  // Assign related remedy ID if available or sent null if not
  if ((network === 'fixed' || network === 'mobile')) {
    const getCurrentAdjacentRemedyRef = window.sessionStorage.getItem('getCurrentAdjacentRemedyRef');
    console.log('MAP param 2', getCurrentAdjacentRemedyRef, params.adjacent_remedy_ref);
    // Add null
    if (getCurrentAdjacentRemedyRef === 'null') {
      console.log('MAP param 3', params.adjacent_remedy_ref);
      params.adjacent_remedy_ref = null;
    }
    else {
      console.log('MAP param 4', params.adjacent_remedy_ref);
      params.adjacent_remedy_ref = getCurrentAdjacentRemedyRef;
    }
  }
  console.log('MAP param 5', params.adjacent_remedy_ref);
  // The following lines were used to send fields up to the endpoint that
  // were not implemented as part of the form, but didn't have a sensible
  // default value. This is commented out as we currently have values for
  // all the api fields
  /*
  // unknown fields, pass up as null
  const unknownFields = [
    // fields that should be included, but set to null
  ];
  unknownFields.forEach((param) => {
    params[param] = null;
  });
  */
  return params;
};

// Following method is used for Mobile VINE update API call params
const getCrqParametersFromFormDataAndUserVINE = (formData, user, newStatus = null, existingFixedRefId, getRelCoordinatorId) => {
  const crqData = formData;
  if (!crqData) { return null; }

  const params = {};
  console.log('get before param formData Vine', formData, sectionParameterFieldMap);
  /* parameters from form section data */
  sectionParameterFieldMap.forEach(({ sectionId, fields }) => {
    fields.forEach(({
      param,
      field,
      asNumber,
      asCommaSeparatedString,
      asArray,
    }) => {
      params[param] = getFieldValueForParameters({
        formData: crqData,
        sectionId,
        fieldId: field,
        asNumber,
        asCommaSeparatedString,
        asArray,
      });
    });
  });

  const network = 'mobile';
  params.id = null;
  params.network = network;
  params.timing = 'Normal';
  params.timing_reason = null;
  params.first_site_implementation = 'No';
  params.last_implementation_failed = 'No';
  params.testing_status = 'Yes:WI evidence added';
  params.has_acceptance = 'Yes';
  params.regression_possible = 'Yes';
  params.regression_tested = 'Yes';
  params.change_scope_tech = 'Data Migration/Upgrade';
  params.change_scope_domain = 'Single Domain';
  params.affected_cis_resilient = 'Yes';
  params.service_outage_required = 'No';
  params.service_outage_required_regression = 'No';
  params.service_outage_duration = 'No Outage';
  // Same As Fixed
  params.impact = DEFAULT_IMPACT_MOBILE;
  params.failed_implementation_critical = null;
  params.backout_achievable = null;
  params.testing = null;
  params.software_status = null;
  params.technology_status = null;
  params.vendor_support = null;
  params.multi_site_affecting = null;
  params.implementer_experience = null;
  params.prep_plans_completed = null;
  params.customer_impact = null;
  params.data_impact = null;
  params.lead_time_provided = null;
  params.lab_evidence_required = null;
  params.it_approval_required = null;
  params.it_approval_exclusion = null;
  params.outage_start_date = null;
  params.outage_end_date = null;
  params.service = 'Voice';
  // Same As fixed
  // params.summary = crqData.summary;
  // params.notes = crqData.notes;
  params.customer_impact_statement = null;
  params.change_reason = 'Non-Project';
  params.product_cat_1 = 'External Service';
  params.product_cat_2 = 'Messaging';
  params.product_cat_3 = null;
  params.op_cat_1 = 'Configure';
  params.op_cat_2 = 'Software';
  params.op_cat_3 = 'Network Service';
  params.tmbs = 'Not TMBS Affecting';
  params.babt_notify = null;
  params.iar_number = null;
  params.mvno = 'No';
  params.comms_required = 'No';
  params.company = null;
  params.region = null;
  params.site_group = null;
  params.site = null;
  params.product_name = null;
  params.product_model = null;
  params.manufacturer = null;
  params.pou = null;
  params.rel_project_id = null;
  params.customer = null;
  params.rel_incident_id = 'Incident';
  params.critical_customers = null;
  params.follow_approved_plan = null;
  params.deliver_expected_benefits = null;
  params.cause_an_incident = null;
  params.complete_within_approved_window = null;
  params.change_regressed = null;
  params.impacted_inventory_updated = null;
  params.actual_start_date = null;
  params.actual_end_date = null;
  params.status_reason = null;
  params.failure_review_q1 = null;
  params.failure_review_q3 = null;
  params.failure_review_q2 = null;
  params.failure_regression_details = null;
  params.failure_incident_reference = null;
  params.impacted_location = null;
  params.status = 'Planning In Progress';
  params.risk_level = 'Risk Level 4';
  params.coordinator = getRelCoordinatorId ? getRelCoordinatorId : 'mv8'; // crqData.coordinatorId;
  params.coordinator_name = null; // crqData.coordinatorName;
  params.coordinator_group = 'Fixed Line'; // crqData.coordinatorGroup;
  params.peer_reviewer = null;
  params.peer_reviewer_group = null;
  params.peer_reviewer_name = null;
  // data from auth
  const {
    firstName,
    lastName,
    remedyIds,
  } = user;

  // requester is the remedy id of logged in user, unless existing crq already has requester value
  params.requester = crqData.requester ? crqData.requester : remedyIds[network];
  // requester name is firstname and lastname of the logged in user, unless existing crq already has requester_name
  params.requester_name = crqData.requesterName ? crqData.requesterName : `${firstName} ${lastName}`;
  params.priority = 'Low';
  params.urgency = '4-Low';
  params.change_manager = 'ace.manager';
  params.change_manager_group = 'Change Management';
  params.other_line_operator = 'No';
  // Fixed Ref CRQ ID
  params.adjacent_remedy_ref = existingFixedRefId;

  console.log('INNER MOBILE PARAM', params);
  return params;
};

// Following method is used for Mobile VINE update API call params for REUSE reference CRQ (reuse, cancel, postpone)
const getCrqParametersFromFormDataRemedyRef = (formData, formDataFixed, getRelCoordinatorId, newStatus, selectedReason, isRefPostponeReason, refPostponeReason1, refPostponeReason2, refPostponeReason3) => {
  const crqData = formData;
  const {
    'scheduled-start-date': scheduledStartDate,
    'scheduled-end-date': scheduledEndDate,
  } = formDataFixed.dataByFormSectionId.START_AND_END_DATE.dataByFieldId;

  console.log('start date', formDataFixed);
  if (!crqData) { return null; }

  let params = {};
  console.log('get before param formData Vine resue>>', formData);

  params = {
    ...crqData,
  };

  params = {
    ...params,
    coordinator: getRelCoordinatorId ? getRelCoordinatorId : params.coordinator,
    status: newStatus,
    status_reason: selectedReason,
    scheduled_start_date: scheduledStartDate && newStatus !== 'Cancelled' ? scheduledStartDate.value : params.scheduled_start_date,
    scheduled_end_date: scheduledEndDate && newStatus !== 'Cancelled' ? scheduledEndDate.value : params.scheduled_end_date,
  };

  const remedyRefReason1 = 'Your related CRQ has been postponed for 1st time';
  const remedyRefReason2 = 'Your related CRQ has been postponed for 2nd time';
  const remedyRefReason3 = 'Your related CRQ has been postponed for 3rd time';

  console.log('postponeparams', crqData.postpone_reason1);
  if (isRefPostponeReason && crqData.postpone_reason1 === undefined) {
    console.log('postponeparams++++++++', crqData.postpone_reason1);
    params.postpone_reason1 = remedyRefReason1;
  }
  if (crqData.postpone_reason1 !== undefined && crqData.postpone_reason2 === undefined) {
    console.log('postponeparams22222', crqData.postpone_reason1, crqData.postpone_reason2);
    params.postpone_reason1 = remedyRefReason1;
    params.postpone_reason2 = remedyRefReason2;
  }
  if (crqData.postpone_reason1 !== undefined && crqData.postpone_reason2 !== undefined && crqData.postpone_reason3 === undefined) {
    console.log('postponeparams3333', crqData.postpone_reason1, crqData.postpone_reason2);
    params.postpone_reason1 = remedyRefReason1;
    params.postpone_reason2 = remedyRefReason2;
    params.postpone_reason3 = remedyRefReason3;
  }

  // params.status = newStatus;
  // params.status_reasone = selectedReason;
  console.log('After reuse MOBILE PARAM', params);
  return params;
};

export {
  getCrqParametersFromFormDataAndUser,
  getCrqParametersFromFormDataAndUserChangeAnalyst,
  getCrqParametersFromFormDataAndUserAssignToMe,
  getCrqParametersFromFormDataAndUserVINE,
  getCrqParametersFromFormDataRemedyRef,
  getFormDataFromState,
  getExistingCrqIdFromState,
  DEFAULT_PRIORITY,
  DEFAULT_URGENCY,
};
